import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc88df9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skills__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Skill = _resolveComponent("Skill")!
  const _component_Card = _resolveComponent("Card")!
  const _component_AddNewSkill = _resolveComponent("AddNewSkill")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      title: _ctx.$t('skills'),
      class: "skills"
    }, {
      buttons: _withCtx(() => [
        _createVNode(_component_IconButton, {
          hint: _ctx.$t('add-new-skill'),
          variant: "transparent",
          type: "PlusIcon",
          onClick: _ctx.add
        }, null, 8, ["hint", "onClick"])
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characters[_ctx.current].skills, (skill, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: _ctx.characters[_ctx.current].name + index + skill.name
            }, [
              _createVNode(_component_Skill, {
                skill: skill,
                onRemove: ($event: any) => (_ctx.remove(index)),
                onUpdate: (newSkill) => _ctx.update(newSkill, index)
              }, null, 8, ["skill", "onRemove", "onUpdate"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.addModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addModal) = $event)),
      title: _ctx.$t('add-new-skill')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddNewSkill, {
          "existed-skills": _ctx.characters[_ctx.current].skills,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addModal = false)),
          onAdd: _ctx.addSkill
        }, null, 8, ["existed-skills", "onAdd"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}